import React__default, { useEffect } from 'react';
import './Pagination.scss.js';
import { classnames } from '../../../utils/classnames.js';
import Input from '../Input/Input.js';
import ArrowsChevronLeft from '../../../assets/icons/resultDir/ArrowsChevronLeft.js';
import ArrowsChevronRight from '../../../assets/icons/resultDir/ArrowsChevronRight.js';

var Pagination = function Pagination(_ref) {
  var count = _ref.count,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$isSimple = _ref.isSimple,
      isSimple = _ref$isSimple === void 0 ? false : _ref$isSimple,
      _ref$hidePageInput = _ref.hidePageInput,
      hidePageInput = _ref$hidePageInput === void 0 ? false : _ref$hidePageInput,
      currentPage = _ref.currentPage,
      onChangePage = _ref.onChangePage,
      _ref$disabledPages = _ref.disabledPages,
      disabledPages = _ref$disabledPages === void 0 ? [] : _ref$disabledPages;
  var FIRST_PAGE_LABEL = 1;
  var MIN_PAGE_NUMBER = 1;
  var STEP = 1;
  var STEP_BEFORE_SHOWING_DOTS = 4;
  var PAGES_WITHOUT_DOTS = 7;
  var PAGES_WITHOUT_NUMBER_SELECT = 20;
  useEffect(function () {
    var initialPage = currentPage > 0 && currentPage <= count ? currentPage : FIRST_PAGE_LABEL;

    while (disabledPages.includes(initialPage) && initialPage <= count) {
      initialPage += STEP;
    }

    onChangePage(initialPage);
  }, []);
  var firstEllipsisCondition = currentPage > STEP_BEFORE_SHOWING_DOTS;
  var secondEllipsisCondition = currentPage <= count - STEP_BEFORE_SHOWING_DOTS;
  /** клик по номеру страницы */

  var handleClickByPage = function handleClickByPage(newPage) {
    return function () {
      if (!disabledPages.includes(newPage) && !disabled) {
        onChangePage(newPage);
      }
    };
  };
  /** клик по левому шеврону */


  var handleClickByLeftChevron = function handleClickByLeftChevron() {
    var newPage = currentPage - STEP;

    while (disabledPages.includes(newPage) && newPage >= MIN_PAGE_NUMBER) {
      newPage -= STEP;
    }

    if (newPage >= MIN_PAGE_NUMBER && !disabled) {
      onChangePage(newPage);
    }
  };
  /** клик по правому шеврону */


  var handleClickByRightChevron = function handleClickByRightChevron() {
    var newPage = currentPage + STEP;

    while (disabledPages.includes(newPage) && newPage <= count) {
      newPage += STEP;
    }

    if (newPage <= count && !disabled) {
      onChangePage(newPage);
    }
  };
  /** ввод страницы вручную */


  var handleInsertPage = function handleInsertPage(result) {
    var page = Number(result.debounceString);

    if (!page && !disabled) {
      onChangePage(MIN_PAGE_NUMBER);
    }

    if (page >= MIN_PAGE_NUMBER && page <= count) {
      onChangePage(page);
    }
  };
  /** отрисовать номер странички */


  var getPageLabel = function getPageLabel(label) {
    var pageDisabled = disabled || disabledPages.includes(label);
    return /*#__PURE__*/React__default.createElement("button", {
      disabled: pageDisabled,
      className: classnames(isSimple ? 'rf-pagination__label-simple' : 'rf-pagination__label', label === currentPage && "rf-pagination__label".concat(isSimple ? '-simple' : '', "--selected"), pageDisabled && 'rf-pagination__label--disabled'),
      key: label,
      onClick: handleClickByPage(label),
      "data-v-6e52f9c7": ""
    }, isSimple ? null : /*#__PURE__*/React__default.createElement("span", {
      className: "rf-pagination__label-text",
      "data-v-6e52f9c7": ""
    }, label));
  };
  /** отрисовать троеточие */


  var getEllipsis = function getEllipsis() {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "rf-pagination__ellipsis",
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement("span", {
      "data-v-6e52f9c7": ""
    }, " ... "));
  };
  /** отрисовать три номера страничек */


  var getThreePageLabel = function getThreePageLabel(firstLabel, secondLabel, thirdLabel) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, getPageLabel(firstLabel), getPageLabel(secondLabel), getPageLabel(thirdLabel));
  };
  /** отрисовать средние лейблы когда с двух сторон троеточие */


  var getMiddleNumbers = function getMiddleNumbers() {
    if (firstEllipsisCondition && secondEllipsisCondition) {
      return getThreePageLabel(currentPage - STEP, currentPage, currentPage + STEP);
    }

    var doubleStep = STEP * 2;
    var tripleStep = STEP * 3;
    var quadrupleStep = STEP * 4;

    if (currentPage <= STEP_BEFORE_SHOWING_DOTS) {
      return getThreePageLabel(FIRST_PAGE_LABEL + doubleStep, FIRST_PAGE_LABEL + tripleStep, FIRST_PAGE_LABEL + quadrupleStep);
    }

    if (currentPage > count - STEP_BEFORE_SHOWING_DOTS) {
      return getThreePageLabel(count - quadrupleStep, count - tripleStep, count - doubleStep);
    }
  };

  var leftChevronDisabled = disabled || currentPage === FIRST_PAGE_LABEL;
  var rightChevronDisabled = disabled || currentPage === count;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "rf-pagination".concat(disabled ? '--disabled' : '', " ").concat(isSimple && 'rf-pagination__simple'),
    "data-v-6e52f9c7": ""
  }, !isSimple && /*#__PURE__*/React__default.createElement("button", {
    disabled: leftChevronDisabled,
    className: classnames('rf-pagination__chevron-wrapper', 'rf-pagination__chevron-left', leftChevronDisabled && 'rf-pagination__chevron-wrapper--disabled'),
    onClick: handleClickByLeftChevron,
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement(ArrowsChevronLeft, {
    "data-v-6e52f9c7": ""
  })), count <= PAGES_WITHOUT_DOTS ? Array.from({
    length: count
  }, function (item, index) {
    return getPageLabel(index + 1);
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, getPageLabel(FIRST_PAGE_LABEL), firstEllipsisCondition ? getEllipsis() : getPageLabel(FIRST_PAGE_LABEL + STEP), getMiddleNumbers(), secondEllipsisCondition ? getEllipsis() : getPageLabel(count - STEP), getPageLabel(count)), !isSimple && /*#__PURE__*/React__default.createElement("button", {
    disabled: rightChevronDisabled,
    className: classnames('rf-pagination__chevron-wrapper', 'rf-pagination__chevron-right', rightChevronDisabled && 'rf-pagination__chevron-wrapper--disabled'),
    onClick: handleClickByRightChevron,
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement(ArrowsChevronRight, {
    "data-v-6e52f9c7": ""
  })), count > PAGES_WITHOUT_NUMBER_SELECT && !hidePageInput && /*#__PURE__*/React__default.createElement(Input, {
    className: "rf-pagination__input",
    placeholder: "\u2116 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B",
    onDebounce: handleInsertPage,
    "data-v-6e52f9c7": ""
  }));
};

export { Pagination as default };
